// src/features/task/services/index.ts
// 聚合所有模組，組合成 taskService 物件對外輸出
import { taskSubscriptionMethods } from './taskSubscriptions';
import { taskQueryMethods } from './taskQueries';
import { taskCRUDMethods } from './taskCRUD';
import { taskOperationMethods } from './taskOperations';
import { taskTimeBoxMethods } from './taskTimeBox';

export const taskService = {
  ...taskSubscriptionMethods,
  ...taskQueryMethods,
  ...taskCRUDMethods,
  ...taskOperationMethods,
  ...taskTimeBoxMethods,
};
